import { IndustryEnumOptions } from "@boundless/bl-api-client/public/models/IndustryEnumLabels"
import { RevenueTrendEnumOptions } from "@boundless/bl-api-client/public/models/RevenueTrendEnumLabels"

import { FormChipGroup } from "@/components/form-elements/FormChipGroup"
import { FormMoneyInput } from "@/components/form-elements/FormMoneyInput"
import { FormSelect } from "@/components/form-elements/FormSelect"
import type { FundReadyIntakeFormValues } from "@/lib/fundready/schema"

const MONTHS_IN_BUSINESS_OPTIONS = [
  { value: 3, label: "Under 6 months" },
  { value: 9, label: "6-12 months" },
  { value: 18, label: "1-2 years" },
  { value: 42, label: "2-5 years" },
  { value: 72, label: "5+ years" },
]

export function StepBusiness() {
  return (
    <>
      <FormSelect<FundReadyIntakeFormValues>
        name="industry"
        label="Industry"
        placeholder="Select your industry"
        options={IndustryEnumOptions}
      />
      <FormChipGroup<FundReadyIntakeFormValues, number>
        name="monthsInBusiness"
        label="Time in business"
        options={MONTHS_IN_BUSINESS_OPTIONS}
      />
      <FormMoneyInput<FundReadyIntakeFormValues>
        name="monthlyRevenue"
        label="Average monthly revenue (last 6 months)"
        placeholder="$85,000"
      />
      <FormChipGroup<
        FundReadyIntakeFormValues,
        FundReadyIntakeFormValues["revenueTrend"]
      >
        name="revenueTrend"
        label="Annual revenue trend"
        options={RevenueTrendEnumOptions}
      />
    </>
  )
}
